import { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { importSpreadsheet } from '../endpoints/import-spreadsheet';
import { transformPartialQuoteLineWithDefaults } from '../utilities/transform-quote-line';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';

function importSpreadsheetFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof importSpreadsheet.Types.ResultType>,
) {
  for (const row of action.payload) {
    const quoteLine = transformPartialQuoteLineWithDefaults(row, state);

    state.quoteLineUuids.push(quoteLine.uuid);
    state.quoteLines[quoteLine.uuid] = {
      ...quoteLine,
      inventory: row.inventory,
    };
  }

  state.dialog = null;
}

export function importSpreadsheetReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    importSpreadsheet.matchFulfilled,
    withSaveStateUpdate(importSpreadsheetFulfilled),
  );
}
